import styled from 'styled-components';
import { blue } from '../../../../styled';

export const Link = styled.a`color: ${blue}`;
